import Requester from "./Requester";

interface CreateDTO {
    clientId: number
    amount: number
    currency: string
}

export function getCategory(alias: string, limit: number = 10, page: number = 1, search: string | null = null, filters: any = {}, options) {
    const requester = new Requester();

    const parameterFilters: any = [];

    console.log(filters)

    Object.keys(filters).forEach((key) => {
        parameterFilters.push({
            name: key,
            value: filters[key],
        });
    })

    console.log(parameterFilters)

    return requester.get(requester.getUrl(`api/frontend/categories/${alias}`, [
        { name: 'limit', value: limit },
        { name: 'page', value: page },
        { name: 'search', value: search },
        ...parameterFilters,
    ]), {
        signal: options.signal
    })
}

export function getCollection(alias: string, limit: number = 10, page: number = 1, search: string | null = null, filters: any = {}, options) {
    const requester = new Requester();

    const parameterFilters: any = [];

    console.log(filters)

    Object.keys(filters).forEach((key) => {
        parameterFilters.push({
            name: key,
            value: filters[key],
        });
    })

    return requester.get(requester.getUrl(`api/frontend/collections/${alias}`, [
        { name: 'limit', value: limit },
        { name: 'page', value: page },
        { name: 'search', value: search },
        ...parameterFilters,
    ]), {
        signal: options.signal
    })
}

export default {
    getCategory,
    getCollection,
}